import type { NodeRenderer } from '../generateNodes';
import type { TextNode } from '../schema';

export const TextRenderer: { text: NodeRenderer<TextNode> } = {
  text: ({ node }) => node.text,
};
